import React from "react";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  error?: string;
}

export function Input({ label, hint, error, className = "", ...props }: InputProps) {
  return (
    <label className="block">
      {label && (
        <span
          className="text-xs font-medium mb-1.5 block"
          style={{ color: "var(--c-text-secondary)" }}
        >
          {label}
        </span>
      )}
      <input
        className={`w-full rounded-lg px-3 py-2 text-sm transition-all duration-200 focus:outline-none ${className}`}
        style={{
          backgroundColor: "var(--c-input-bg)",
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: error ? "var(--c-danger)" : "var(--c-border)",
          color: "var(--c-text)",
        }}
        onFocus={(e) => {
          e.currentTarget.style.borderColor = "var(--c-primary)";
          props.onFocus?.(e);
        }}
        onBlur={(e) => {
          e.currentTarget.style.borderColor = error ? "var(--c-danger)" : "var(--c-border)";
          props.onBlur?.(e);
        }}
        {...props}
      />
      {hint && !error && (
        <span className="text-[11px] mt-1 block" style={{ color: "var(--c-text-faint)" }}>
          {hint}
        </span>
      )}
      {error && (
        <span className="text-[11px] mt-1 block" style={{ color: "var(--c-danger)" }}>
          {error}
        </span>
      )}
    </label>
  );
}
